import { FormikProps, connect } from 'formik';
import * as React from 'react';

export interface IOwnProps {
  formikContext: FormikProps<any>;
}

class FormikErrorFocus extends React.Component<IOwnProps & { formik: FormikProps<any> }, {}> {

  componentDidUpdate(prevProps: IOwnProps & { formik: FormikProps<any> }) {
    const errorElements = document.querySelectorAll('input.field--error') as NodeListOf<HTMLInputElement>;
    if (!this.props.formik.isValid && this.props.formik.isSubmitting && errorElements.length > 0) {
      errorElements[0].focus();
    }
  }

  render() {
    return null;
  }
}

export default connect<IOwnProps, any>(FormikErrorFocus);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/FormikErrorFocus/FormikErrorFocus.tsx